import { render, staticRenderFns } from "./QuoteItemsAuthorise.vue?vue&type=template&id=b718a922"
import script from "./QuoteItemsAuthorise.vue?vue&type=script&lang=js"
export * from "./QuoteItemsAuthorise.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b718a922')) {
      api.createRecord('b718a922', component.options)
    } else {
      api.reload('b718a922', component.options)
    }
    module.hot.accept("./QuoteItemsAuthorise.vue?vue&type=template&id=b718a922", function () {
      api.rerender('b718a922', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/QuoteItemsAuthorise.vue"
export default component.exports